function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";
import { Table as MaterialTable, TableCell as MaterialTableCell, TableHead as MaterialTableHead, TableBody as MaterialTableBody, TableRow as MaterialTableRow } from "@material-ui/core";
import styled from "styled-components";
import PropTypes from "prop-types";

var Table = function Table(_ref) {
  var children = _ref.children,
      props = _objectWithoutProperties(_ref, ["children"]);

  return React.createElement(StyledTable, props, children);
};

var TableCell = function TableCell(_ref2) {
  var children = _ref2.children,
      props = _objectWithoutProperties(_ref2, ["children"]);

  return React.createElement(MaterialTableCell, props, children);
};

var TableBody = function TableBody(_ref3) {
  var children = _ref3.children,
      props = _objectWithoutProperties(_ref3, ["children"]);

  return React.createElement(MaterialTableBody, props, children);
};

var TableHead = function TableHead(_ref4) {
  var children = _ref4.children,
      props = _objectWithoutProperties(_ref4, ["children"]);

  return React.createElement(MaterialTableHead, props, children);
};

var TableRow = function TableRow(_ref5) {
  var children = _ref5.children,
      props = _objectWithoutProperties(_ref5, ["children"]);

  return React.createElement(MaterialTableRow, props, children);
};

var StyledTable = styled(MaterialTable).withConfig({
  displayName: "Table__StyledTable",
  componentId: "sc-173sj9g-0"
})(["td,th{padding:0px 8px;}td{line-height:2rem;font-size:", ";}tbody > tr:hover{background-color:", ";}"], function (_ref6) {
  var theme = _ref6.theme;
  return theme.fsSmall;
}, function (props) {
  return props.theme.greyBackground;
});
Table.propTypes = {
  /**
   * Children passed to the Table.
   */
  children: PropTypes.node
};
Table.Head = TableHead;
Table.Body = TableBody;
Table.Row = TableRow;
Table.Cell = TableCell;
export default Table;